import { render, staticRenderFns } from "./IRCLicenses.vue?vue&type=template&id=89096386"
import script from "./IRCLicenses.vue?vue&type=script&lang=js"
export * from "./IRCLicenses.vue?vue&type=script&lang=js"
import style0 from "./IRCLicenses.vue?vue&type=style&index=0&id=89096386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports